import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ProductEncodeSplashesViewModel } from '@models/api.models';
import { SettingsService } from '@core/services/settings.service';
import { map, take } from 'rxjs/operators';
import { CampaignTypes, SplashesAndCampaigns } from '@features/product/product.models';

@Pipe({
    name: 'firstSplash',
    standalone: true
})
export class FirstSplashPipe implements PipeTransform {
    private readonly settingsService: SettingsService = inject(SettingsService);

    transform(
        { activeSplashes, activeCampaigns }: SplashesAndCampaigns,
        exclude: CampaignTypes[] = []
    ): Observable<ProductEncodeSplashesViewModel | undefined> {
        if (!activeSplashes?.length && !activeCampaigns?.length) {
            return of(undefined);
        }

        return this.settingsService.settings$.pipe(
            take(1),
            map(({ productSettings }) => {
                const splashes =
                    productSettings?.encodeSplashes?.filter(
                        splash =>
                            activeSplashes
                                ?.filter(activeSplash => !exclude.includes(activeSplash?.type as CampaignTypes))
                                .some(active => active?.id === splash.encodeId) ||
                            activeCampaigns
                                ?.filter(
                                    activeCampaign => !exclude.includes(activeCampaign?.campaignType as CampaignTypes)
                                )
                                .some(
                                    active => active.code === splash.encodeId || active.campaignId === splash.encodeId
                                )
                    ) || [];
                return splashes.length ? splashes[0] : undefined;
            })
        );
    }
}
